import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { PageLayout } from './components/PageLayout';
import { loginRequest } from './authConfig';
import { callMsGraph } from './graph';
import { ProfileData } from './components/ProfileData';

import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import '../../App.css';
import CustomButton from "../../components/ui/CustomButton";
import GroupList from './GroupList';
import AzureADGroupList from './AzureADGroups';

/**
 * Renders information about the signed-in user or a button to retrieve data about the user
 */

const ProfileContent = () => {
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);
    const [groupData, setGroupData] = useState(null);
    const navigate = useNavigate();

    function RequestProfileData() {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
                //scopes: ['group.read.all','user.read']
            })
            .then((response) => {
                callMsGraph(response.accessToken).then((response) => setGraphData(response));
                console.log('groups-->');
                console.log(response.idTokenClaims.groups);
                setGroupData(response.idTokenClaims.groups);
                console.log('idtoken-->');
                console.log(response.idToken);
            });

           // navigate("/dashboard");
    }

    return (
        <>
            <h5 className="profileContent">Welcome {accounts[0].name}</h5>
            {graphData ? (
                <ProfileData graphData={graphData} />
            ) : (
                <CustomButton variant="secondary" onClick={RequestProfileData}>
                    Request Profile
                </CustomButton>

                
                
            )}

            <div>
                <h2>Groups</h2>
                <table border="1">

                
                    {groupData && groupData.map((group, index) => (
                        <tr>
                        <td>{index+1}</td>  
                        <td> {group} </td>
                        </tr>
                    ))}
                </table>
            </div>


            {/* <AzureADGroupList/> */}
        </>
    );
};

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = () => {
    return (
        <div className="App">
            <AuthenticatedTemplate>
                <ProfileContent />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                <h5 className="card-title">Please sign-in to see your profile information.</h5>
            </UnauthenticatedTemplate>
        </div>
    );
};

export default function AzureADLogin() {
    return (
        <PageLayout>
            <MainContent />
        </PageLayout>
    );
}
